<template>
  <div style="height: auto; min-height: 500px;">
    <div class="phone-selector-container">
      <div class="col" style="margin-bottom: 2rem;" v-if="$whitelabel.showLogo()">
        <img :src="require('../../../assets/sqrql_logo.png')" width="160px" height="160px">
      </div>
      <div class="col-12" style="margin-top: 3rem; margin-bottom: 3rem; min-height: 222px;" v-if="processing">
        <b-spinner variant="teal" label="Spinning"></b-spinner>
      </div>
      <div class="col-12" style="margin-top: 3rem; margin-bottom: 3rem;" v-else>
        <div class="col-12" style="min-height: 60px;">
          <b-alert variant="danger" :show="isAlert">{{ alert }}</b-alert>
          <b-alert variant="success" :show="isSuccess">{{ successMessage }}</b-alert>
        </div>
        <form method="post" @submit.prevent="reset" name="reset">
          <div class="col-12">
            <div class="col-12">
              <b-form-input
                id="username"
                v-model="username"
                type="text"
                required
                :placeholder="$t('resetpassword.username')"
              ></b-form-input>
            </div>
          </div>
          <div class="col-10 offset-1" style="margin-top: 2rem;">
            <b-button variant="primary" type="submit" block style="background-color: #009AB1; border-color: #009AB1;">{{ $t('resetpassword.submit') }}</b-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'reset-email',
    mounted () {
      localStorage.removeItem('fonestorm-token')
      localStorage.removeItem('device')
      localStorage.removeItem('DND')
    },
    data () {
      return {
        username: '',
        alert: this.$t('resetpassword.resetFailAlert1'),
        isAlert: false,
        processing: false,
        isSuccess: false,
        successMessage: this.$t('resetpassword.resetSuccessAlert1')
      }
    },
    methods: {
      reset: async function () {
        var self = this
        try {
          if (self.username) {
            // eslint-disable-next-line
            var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/

            if (filter.test(self.username)) {
              self.processing = true
              self.isAlert = false
              await axios.post(`${process.env.MYR_ROOT}/password_resets?email=${self.username}&template=fractelfone`, {})
              self.processing = false
              self.isSuccess = true
            } else {
              self.isAlert = true
              self.processing = false
              self.isSuccess = false
              self.alert = self.$t('resetpassword.resetFailAlert2')
            }
          }
        } catch (error) {
          self.alert = self.$t('resetpassword.resetFailAlert1')
          self.isAlert = true
          self.processing = false
          self.isSuccess = false
        }
      }
    }
  }
</script>

<style scopped>
.phone-selector-container {
  background-color: white;
  max-width: 420px !important;
  padding: 20px !important;
  margin: 0 auto 0 auto !important;
  height: 552px !important;
  width: 420px !important;
  overflow: hidden;
  text-align: center !important;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}
.text-teal {
  color: #009AB1;
}
</style>
